<script>
	const accountService = require('services/accountService');
	const userContext = require('core/userContext');
	const model = require('model/model');
	const _ = require('underscore');

	module.exports = {
		props: ['editAccount', 'originalAccount', 'isExternalLogin'],
		components: {
			'input-item-with-label': require('components/input-item-with-label.vue').default,
			'load-mask': require('components/load-mask.vue').default,
			'info-icon': require('components/svg/info-icon.vue').default,
			'form-submitter': require('components/form-submitter.vue').default
		},
		data() {
			let subscribeTooltip = `Uh oh!
			We can\'t seem to add you to our email list.
			Please <a href="https://help.readworks.org/" target="_blank">send a message to our help center</a>
			and we\'ll fix the problem.`;
			return {
				subscriptionLoading: true,
				subscribed: null,
				subscribeTooltip
			};
		},
		computed: {
			subscriptionItem() {
				let subscribed = this.subscribed;
				let item = {
					text: 'I want to receive FREE reading passages, activities, and teaching tools in my email',
					id: 'email-subscribe',
					selected: subscribed,
					disabled: subscribed !== true && subscribed !== false
				};

				return item;
			}
		},
		methods: {
			submitHandler(data) {
				return accountService.teacherUpdateAccount(data).then(result => {
					model.set('userContext', _.extend(userContext.getUserData(), data));
					return result;
				});
			},
			onSubscribeChange() {
				let subscribed = this.subscribed;
				let prms = null;
				if (subscribed === true) {
					prms = accountService.unsubscribe();
				} else if (subscribed === false) {
					prms = accountService.subscribe();
				}

				if (prms) {
					this.subscriptionLoading = true;
					prms
						.then(() => {
							this.subscribed = !subscribed;
						})
						.finally(() => (this.subscriptionLoading = false));
				}

				return prms;
			}
		},
		mounted() {
			this.subscriptionLoading = true;
			/*accountService.getSubscriptionStatus()
			.then(status => {
				this.subscribed = status;
			})
			.finally(() => this.subscriptionLoading = false);*/
		}
	};
</script>
<style lang="scss">
	form.account {
		.subscribe-checkbox {
			display: inline-block;
			position: relative;

			.info-icon {
				cursor: pointer;
				vertical-align: text-top;
			}

			.info-icon,
			.input-item-with-label {
				display: inline-block;
			}
		}
	}
</style>
<template>
	<div class="main-content wrapper">
		<form-submitter
			v-if="editAccount"
			class="form account"
			novalidate
			form-name="editAccount"
			:form-data.sync="editAccount"
			:submit-to="submitHandler"
			:delta="originalAccount">
			<auto-form-row
				:data.sync="editAccount.firstName"
				type="firstName"
				label="First Name"
				required>
			</auto-form-row>
			<auto-form-row
				:data.sync="editAccount.lastName"
				type="lastName"
				label="Last Name"
				required>
			</auto-form-row>
			<auto-form-row
				:data.sync="editAccount.email ?? 'Email'"
				type="email"
				label="Email"
				isreadonly>
			</auto-form-row>
			<div
				v-if="!isExternalLogin && !originalAccount.google"
				class="form-row change-email margin-top-small">
				<div class="form-row-input">
					<a data-modal="#modal-change-account-email">Change Email</a>
				</div>
			</div>
			<div v-if="!isExternalLogin">
				<hr />
				<a data-modal="#modal-change-account-password">Change Password</a>
			</div>
			<auto-form-row
				:all-valid="editAccount.allValid"
				type="submit"
				row-class="-full-width">
				Save Changes
			</auto-form-row>
		</form-submitter>
		<!-- end .main-content -->
		<email-modal
			v-if="!isExternalLogin"
			prompt-for-current
			confirm
			min-length="6"
			button-text="Change Email"
			modal-title="Change Email"
			modal-id="modal-change-account-email"></email-modal>
		<password-modal
			v-if="!isExternalLogin"
			mode="teacher"
			prompt-for-current
			confirm
			:min-length="8"
			button-text="Change Password"
			modal-title="Change Password"
			modal-id="modal-change-account-password"></password-modal>
	</div>
</template>
